import { mergeAllUrls } from 'functions/mergeAllUrls'

export const externalLinkRedirect = '/external-redirect'
export const externalLink = 'link'

export const externalLinkRedirectPath = mergeAllUrls(externalLinkRedirect)
